// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-card_amenities ul li svg.active {
  fill: black;
}
.property-card_amenities ul li svg.active {
  fill: black;
}
.property-card_amenities ul li svg:first-of-type {
  display: block;
}
.property-card_amenities {
  padding: 0;
  display: block;
  height: 45px !important;
  flex: 0 1 66.666667% !important;
}
.occupancy_mobile.mobile {
  display: none;
}

.map-close {
  display: none;
}

.property-card_amenities ul li {
  display: none;
}

.property-card_amenities ul li.active {
  display: flex;
}

.main-search .form-container > div {
  border-right: none;
}

@media (max-width: 599px) {
  .occupancy_mobile.mobile {
    display: block;
    position: absolute;
    top: 65px;
    left: 30px;
    z-index: 9;
  }
  .DateRangePickerInput {
    padding: 10px 0 0 20px;
  }
  .main-search .form-container > div {
    width: 100%;
    padding: 0;
    height: 95px;
  }

  .property-search-list {
    margin-top: 5px;
  }
  .property-card {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.355);
    margin: 0 10px 20px 10px;
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 20px !important;
  }

  .property-card_tabs {
    flex-direction: column !important;
  }

  .property-card_tabs > div {
    width: 100% !important;
  }
  .property-card_amenities {
    padding: 0 10px;
  }

  .property-card_book a {
    font-size: 1rem;
    padding: 10px 20px;
  }
  .main-search_occupancy .occupancy_filter {
    right: 0;
    padding-top: 10px;
    height: auto;
    bottom: 0;
  }

  .main-search_occupancy.active > div:not(.occupancy_filter) {
    padding: 0;
  }

  .main-search_occupancy.active {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: 100;
  }

  .occupancy_filter-container {
    padding-inline: 10px;
  }

  .main-search_mobile-filters {
    flex-wrap: nowrap;
    gap: 5px;
  }

  .main-search_mobile-filters svg {
    width: 22px;
    height: 22px;
  }

  .main-search_mobile-filters span button {
    border-radius: 3px;
    height: 28px;
  }

  .main-search_mobile-filters span:first-child {
    border: none;
  }

  .main-content {
    padding-bottom: 80px;
  }

  .pagination-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 10px;
    padding-right: 80px;
    height: 80px;
    background: #fff;
    border-top: 1px solid #dedede;
    z-index: 2;
  }

  .pagination-wrapper.full-width {
    padding-right: 15px;
  }

  .property-meta_total {
    display: none;
  }

  .site-content .sidebar.map {
    width: 100%;
    z-index: 100;
    bottom: 80px !important;
    /*display: none;*/
  }

  /* .site-content .sidebar.map.--active {
    display: block;
  } */

  .map-close {
    display: block;
  }

  .DayPicker_weekHeader__vertical {
    width: 100%;
    margin-left: auto !important;
    transform: translateX(-50%);
  }

  .DayPicker_weekHeader__vertical ul {
    display: flex;
    justify-content: space-around;
    padding-inline: 15px;
  }

  .CalendarMonthGrid_month__hidden {
    width: 100%;
  }

  .CalendarMonthGrid div:first-child {
    width: 100%;
  }

  .property-card_imgblock {
    aspect-ratio: 16/9;
    height: auto;
  }

}
.main-search_occupancy .occupancy_filter__update .cancel,
.main-search_occupancy .occupancy_filter__update .apply {
  width: 50%;
  flex: 1 1 100%;
}
.property-card_book {
  flex: 0 1 33.333334%;
}
.property-card_amenities ul {
  height: 45px;
  align-items: center;
  width: 100%;
}

.property-card_main {
  min-height: 120px;
}

.img-gallery {
  transition: opacity 0.5s ease; /* Transition effect for opacity */
  opacity: 1; /* Starting opacity */
}

.fade-in {
  opacity: 1; /* Fully visible */
}

.fade-out {
  opacity: 0; /* Fully transparent */
}

#map {
  height: 100%;
}

.list-pagination_wrap button[disabled] {
  opacity: 0.5;
  pointer-events: none;
}

@media screen and (min-width: 900px) {
}

.highlight-prop {
  width: 300px;
  position: absolute;
  bottom: 135%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 10px;
  z-index: 999999999999;
  box-shadow: 1px 2px 10px 5px rgba(0, 0, 0, 0.25);
}

.highlight-prop + span {
  background: #212121 !important;
  color: #fff !important;
}

.highlight-prop__images {
  width: 100%;
  aspect-ratio: 16/9;
  background: #d2d2d2;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}

.highlight-prop__img {
  width: 100%;
}

.highlight-prop__images .property-card_imgblock {
  height: 100%;
}

.highlight-prop__content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  padding: 10px;
}

.highlight-prop__content h2 {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
}

.highlight-prop__content h3 {
  margin: 0;
}

.highlight-prop__rates {
  display: flex;
  justify-content: space-between;
}

.--hovered {
  z-index: 9999999999;
}

.highlight-prop__close {
  width: 24px;
  height: 24px;
  color: #fff;
  background: #000;
  outline: none;
  cursor: pointer;
  border-radius: 50%;
  position: absolute;
  z-index: 10;
  top: -12px;
  right: -12px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 300;
  font-size: 14px;
}

.highlight-prop__desc {
  font-size: 12px;
}

[slot="visible-gmp-advanced-markers"] {
  pointer-events: all !important;
  touch-action: initial !important;
}

button.cta.update:disabled {
  background: #999 !important;
  color: #fff !important;
  cursor: default;
}

.offer figure {
  padding: 5px 10px;
}

.property-card_price-book > span,
.property-card_price-book > div,
.property-card_price-book {
  flex-direction: column;
  flex-wrap: nowrap;
}

.price-info {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.fee-price {
  font-size: .75rem;
}

.price-info > *:last-child::after {
  content: "";
  display: block;
}

.discounts-banner {
  background: var(--main-color);
  color: #fff;
  padding: 15px;
  text-align: center;
  cursor: pointer;
}

.discounts-banner p {
  margin: 0;
}

.discounts-modal {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr min-content;
  gap: 20px;
}

.discounts-modal-header {
  display: grid;
  grid-template-columns: 1fr 3fr;
  gap: 15px;
}

.discounts-modal-img img {
  width: 100%;
}

.discounts-modal-details {
  border-radius: 10px;
  background: #f2f2f2;
  color: #666;
  font-size: 0.9em;
  padding: 15px;
  line-height: 1.6;
}

.discounts-modal-heading {
  display: grid;
  gap: 15px;
  grid-template-columns: 100%;
  grid-template-rows: min-content 55px;
  width: 100%;
  overflow: hidden;
}

.discounts-modal-heading a span {
  display: inline-flex;
}

.discounts-modal-heading a {
  display: inline-flex;
  line-height: 1;
  align-items: center;
}

.discounts-modal-title {
  line-height: 1;
  margin: 0;
  font-size: 24px;
  font-weight: 400;
  text-transform: none;
  color: #212121;
}

.discounts-modal-item {
  line-height: 1;
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: var(--main-color);
}

.discounts-modal-actions {
  display: flex;
  gap: 15px;
  justify-content: center;
}

.discounts-modal-actions button {
  border-radius: 5px;
  width: 50%;
  max-width: 300px;
  padding: 14px 30px;
  border: 2px solid var(--main-color);
}

.discounts-modal-actions button:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.discounts-modal-actions button:first-child {
  background: none;
  color: var(--main-color);
}

.discounts-caret {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-bottom: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
  transition: all 0.3s ease;
  margin-left: 5px;
}

.discounts-caret.-down {
  transform: rotate(45deg);
}

.discounts-caret.-up {
  transform: rotate(-135deg);
}

.discounts-modal .ant-select-selector {
  padding: 10px 11px !important;
}

.discounts-modal .ant-select {
  height: auto;
  color: var(--main-color) !important;
}

.discounts-modal .ant-select-selection-item {
  font-weight: 600;
  color: var(--main-color) !important;
}

.discounts-modal .ant-select .ant-select-arrow {
  margin-top: -10px;
  color: var(--main-color);
  font-size: 16px;
}

.ant-select-dropdown .ant-select-item-option {
  align-items: center;
}

.property-card_price-book .price-per-room {
  margin-top: 2px;
  margin-bottom: 0;
  justify-content: flex-start;
}

@media (max-width: 599px) {
  .discounts-modal-img img {
    width: 80%;
    margin: auto;
  }

  .discounts-modal-header {
    grid-template-columns: 1fr;
  }

  .discounts-modal-actions button {
    font-size: 0.8rem;
    padding: 14px 0;
  }

  .discounts-modal-title {
    font-size: 18px;
  }
}

.is-loading .main-content,
.is-loading .sidebar.map {
  background: linear-gradient(
    45deg,
    #f9f9f9,
    #f9f9f9,
    #f9f9f9,
    #f9f9f9 45%,
    #d2d2d2 50%,
    #f9f9f9 55%,
    #f9f9f9,
    #f9f9f9,
    #f9f9f9
  );
  background-size: 600% 600%;
  animation: Skeleton 2s ease infinite;
  min-height: 100%;
}

@keyframes Skeleton {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 75%;
  }
}

.search-results.findhotels .site-header .container-fluid {
  padding-left: 20px;
  padding-right: 20px;
}

.loading-message-bar {
  background: var(--main-color);
  color: #fff;
  display: flex;
  gap: 30px;
  font-size: 21px;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 10000;
}

.loading-message-bar .spinner {
  margin: 0;
}

.loading-message-bar .spinner > div {
  background: #fff;
}

@media (max-width: 900px) {
  .loading-message-bar {
    gap: 10px;
  }

  .site-content-loading .sidebar {
    display: none;
  }
}

.site-content-loading {
  width: 100vw;
  overflow: hidden;
}

.property-card_price-book .price-wrap .strikethrough-price {
  margin-right: 0;
}
`, "",{"version":3,"sources":["webpack://./global.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;EACZ;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,wCAAwC;IACxC,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,QAAQ;IACR,iBAAiB;IACjB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;AAEF;AACA;;EAEE,UAAU;EACV,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B,EAAE,kCAAkC;EACjE,UAAU,EAAE,qBAAqB;AACnC;;AAEA;EACE,UAAU,EAAE,kBAAkB;AAChC;;AAEA;EACE,UAAU,EAAE,sBAAsB;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,+CAA+C;EAC/C,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE;;;;;;;;;;;GAWC;EACD,0BAA0B;EAC1B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".property-card_amenities ul li svg.active {\n  fill: black;\n}\n.property-card_amenities ul li svg.active {\n  fill: black;\n}\n.property-card_amenities ul li svg:first-of-type {\n  display: block;\n}\n.property-card_amenities {\n  padding: 0;\n  display: block;\n  height: 45px !important;\n  flex: 0 1 66.666667% !important;\n}\n.occupancy_mobile.mobile {\n  display: none;\n}\n\n.map-close {\n  display: none;\n}\n\n.property-card_amenities ul li {\n  display: none;\n}\n\n.property-card_amenities ul li.active {\n  display: flex;\n}\n\n.main-search .form-container > div {\n  border-right: none;\n}\n\n@media (max-width: 599px) {\n  .occupancy_mobile.mobile {\n    display: block;\n    position: absolute;\n    top: 65px;\n    left: 30px;\n    z-index: 9;\n  }\n  .DateRangePickerInput {\n    padding: 10px 0 0 20px;\n  }\n  .main-search .form-container > div {\n    width: 100%;\n    padding: 0;\n    height: 95px;\n  }\n\n  .property-search-list {\n    margin-top: 5px;\n  }\n  .property-card {\n    box-shadow: 0 0 7px rgba(0, 0, 0, 0.355);\n    margin: 0 10px 20px 10px;\n    border-radius: 3px;\n    overflow: hidden;\n    margin-bottom: 20px !important;\n  }\n\n  .property-card_tabs {\n    flex-direction: column !important;\n  }\n\n  .property-card_tabs > div {\n    width: 100% !important;\n  }\n  .property-card_amenities {\n    padding: 0 10px;\n  }\n\n  .property-card_book a {\n    font-size: 1rem;\n    padding: 10px 20px;\n  }\n  .main-search_occupancy .occupancy_filter {\n    right: 0;\n    padding-top: 10px;\n    height: auto;\n    bottom: 0;\n  }\n\n  .main-search_occupancy.active > div:not(.occupancy_filter) {\n    padding: 0;\n  }\n\n  .main-search_occupancy.active {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: #fff;\n    z-index: 100;\n  }\n\n  .occupancy_filter-container {\n    padding-inline: 10px;\n  }\n\n  .main-search_mobile-filters {\n    flex-wrap: nowrap;\n    gap: 5px;\n  }\n\n  .main-search_mobile-filters svg {\n    width: 22px;\n    height: 22px;\n  }\n\n  .main-search_mobile-filters span button {\n    border-radius: 3px;\n    height: 28px;\n  }\n\n  .main-search_mobile-filters span:first-child {\n    border: none;\n  }\n\n  .main-content {\n    padding-bottom: 80px;\n  }\n\n  .pagination-wrapper {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 15px 10px;\n    padding-right: 80px;\n    height: 80px;\n    background: #fff;\n    border-top: 1px solid #dedede;\n    z-index: 2;\n  }\n\n  .pagination-wrapper.full-width {\n    padding-right: 15px;\n  }\n\n  .property-meta_total {\n    display: none;\n  }\n\n  .site-content .sidebar.map {\n    width: 100%;\n    z-index: 100;\n    bottom: 80px !important;\n    /*display: none;*/\n  }\n\n  /* .site-content .sidebar.map.--active {\n    display: block;\n  } */\n\n  .map-close {\n    display: block;\n  }\n\n  .DayPicker_weekHeader__vertical {\n    width: 100%;\n    margin-left: auto !important;\n    transform: translateX(-50%);\n  }\n\n  .DayPicker_weekHeader__vertical ul {\n    display: flex;\n    justify-content: space-around;\n    padding-inline: 15px;\n  }\n\n  .CalendarMonthGrid_month__hidden {\n    width: 100%;\n  }\n\n  .CalendarMonthGrid div:first-child {\n    width: 100%;\n  }\n\n  .property-card_imgblock {\n    aspect-ratio: 16/9;\n    height: auto;\n  }\n\n}\n.main-search_occupancy .occupancy_filter__update .cancel,\n.main-search_occupancy .occupancy_filter__update .apply {\n  width: 50%;\n  flex: 1 1 100%;\n}\n.property-card_book {\n  flex: 0 1 33.333334%;\n}\n.property-card_amenities ul {\n  height: 45px;\n  align-items: center;\n  width: 100%;\n}\n\n.property-card_main {\n  min-height: 120px;\n}\n\n.img-gallery {\n  transition: opacity 0.5s ease; /* Transition effect for opacity */\n  opacity: 1; /* Starting opacity */\n}\n\n.fade-in {\n  opacity: 1; /* Fully visible */\n}\n\n.fade-out {\n  opacity: 0; /* Fully transparent */\n}\n\n#map {\n  height: 100%;\n}\n\n.list-pagination_wrap button[disabled] {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n@media screen and (min-width: 900px) {\n}\n\n.highlight-prop {\n  width: 300px;\n  position: absolute;\n  bottom: 135%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #fff;\n  border-radius: 10px;\n  z-index: 999999999999;\n  box-shadow: 1px 2px 10px 5px rgba(0, 0, 0, 0.25);\n}\n\n.highlight-prop + span {\n  background: #212121 !important;\n  color: #fff !important;\n}\n\n.highlight-prop__images {\n  width: 100%;\n  aspect-ratio: 16/9;\n  background: #d2d2d2;\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n\n.highlight-prop__img {\n  width: 100%;\n}\n\n.highlight-prop__images .property-card_imgblock {\n  height: 100%;\n}\n\n.highlight-prop__content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  padding: 10px;\n}\n\n.highlight-prop__content h2 {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.highlight-prop__content h3 {\n  margin: 0;\n}\n\n.highlight-prop__rates {\n  display: flex;\n  justify-content: space-between;\n}\n\n.--hovered {\n  z-index: 9999999999;\n}\n\n.highlight-prop__close {\n  width: 24px;\n  height: 24px;\n  color: #fff;\n  background: #000;\n  outline: none;\n  cursor: pointer;\n  border-radius: 50%;\n  position: absolute;\n  z-index: 10;\n  top: -12px;\n  right: -12px;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 300;\n  font-size: 14px;\n}\n\n.highlight-prop__desc {\n  font-size: 12px;\n}\n\n[slot=\"visible-gmp-advanced-markers\"] {\n  pointer-events: all !important;\n  touch-action: initial !important;\n}\n\nbutton.cta.update:disabled {\n  background: #999 !important;\n  color: #fff !important;\n  cursor: default;\n}\n\n.offer figure {\n  padding: 5px 10px;\n}\n\n.property-card_price-book > span,\n.property-card_price-book > div,\n.property-card_price-book {\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.price-info {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.fee-price {\n  font-size: .75rem;\n}\n\n.price-info > *:last-child::after {\n  content: \"\";\n  display: block;\n}\n\n.discounts-banner {\n  background: var(--main-color);\n  color: #fff;\n  padding: 15px;\n  text-align: center;\n  cursor: pointer;\n}\n\n.discounts-banner p {\n  margin: 0;\n}\n\n.discounts-modal {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content 1fr min-content;\n  gap: 20px;\n}\n\n.discounts-modal-header {\n  display: grid;\n  grid-template-columns: 1fr 3fr;\n  gap: 15px;\n}\n\n.discounts-modal-img img {\n  width: 100%;\n}\n\n.discounts-modal-details {\n  border-radius: 10px;\n  background: #f2f2f2;\n  color: #666;\n  font-size: 0.9em;\n  padding: 15px;\n  line-height: 1.6;\n}\n\n.discounts-modal-heading {\n  display: grid;\n  gap: 15px;\n  grid-template-columns: 100%;\n  grid-template-rows: min-content 55px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.discounts-modal-heading a span {\n  display: inline-flex;\n}\n\n.discounts-modal-heading a {\n  display: inline-flex;\n  line-height: 1;\n  align-items: center;\n}\n\n.discounts-modal-title {\n  line-height: 1;\n  margin: 0;\n  font-size: 24px;\n  font-weight: 400;\n  text-transform: none;\n  color: #212121;\n}\n\n.discounts-modal-item {\n  line-height: 1;\n  margin: 0;\n  font-size: 32px;\n  font-weight: 600;\n  color: var(--main-color);\n}\n\n.discounts-modal-actions {\n  display: flex;\n  gap: 15px;\n  justify-content: center;\n}\n\n.discounts-modal-actions button {\n  border-radius: 5px;\n  width: 50%;\n  max-width: 300px;\n  padding: 14px 30px;\n  border: 2px solid var(--main-color);\n}\n\n.discounts-modal-actions button:disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.discounts-modal-actions button:first-child {\n  background: none;\n  color: var(--main-color);\n}\n\n.discounts-caret {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-bottom: 1px solid var(--main-color);\n  border-right: 1px solid var(--main-color);\n  transition: all 0.3s ease;\n  margin-left: 5px;\n}\n\n.discounts-caret.-down {\n  transform: rotate(45deg);\n}\n\n.discounts-caret.-up {\n  transform: rotate(-135deg);\n}\n\n.discounts-modal .ant-select-selector {\n  padding: 10px 11px !important;\n}\n\n.discounts-modal .ant-select {\n  height: auto;\n  color: var(--main-color) !important;\n}\n\n.discounts-modal .ant-select-selection-item {\n  font-weight: 600;\n  color: var(--main-color) !important;\n}\n\n.discounts-modal .ant-select .ant-select-arrow {\n  margin-top: -10px;\n  color: var(--main-color);\n  font-size: 16px;\n}\n\n.ant-select-dropdown .ant-select-item-option {\n  align-items: center;\n}\n\n.property-card_price-book .price-per-room {\n  margin-top: 2px;\n  margin-bottom: 0;\n  justify-content: flex-start;\n}\n\n@media (max-width: 599px) {\n  .discounts-modal-img img {\n    width: 80%;\n    margin: auto;\n  }\n\n  .discounts-modal-header {\n    grid-template-columns: 1fr;\n  }\n\n  .discounts-modal-actions button {\n    font-size: 0.8rem;\n    padding: 14px 0;\n  }\n\n  .discounts-modal-title {\n    font-size: 18px;\n  }\n}\n\n.is-loading .main-content,\n.is-loading .sidebar.map {\n  background: linear-gradient(\n    45deg,\n    #f9f9f9,\n    #f9f9f9,\n    #f9f9f9,\n    #f9f9f9 45%,\n    #d2d2d2 50%,\n    #f9f9f9 55%,\n    #f9f9f9,\n    #f9f9f9,\n    #f9f9f9\n  );\n  background-size: 600% 600%;\n  animation: Skeleton 2s ease infinite;\n  min-height: 100%;\n}\n\n@keyframes Skeleton {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 100% 75%;\n  }\n}\n\n.search-results.findhotels .site-header .container-fluid {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.loading-message-bar {\n  background: var(--main-color);\n  color: #fff;\n  display: flex;\n  gap: 30px;\n  font-size: 21px;\n  padding: 1rem;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 10000;\n}\n\n.loading-message-bar .spinner {\n  margin: 0;\n}\n\n.loading-message-bar .spinner > div {\n  background: #fff;\n}\n\n@media (max-width: 900px) {\n  .loading-message-bar {\n    gap: 10px;\n  }\n\n  .site-content-loading .sidebar {\n    display: none;\n  }\n}\n\n.site-content-loading {\n  width: 100vw;\n  overflow: hidden;\n}\n\n.property-card_price-book .price-wrap .strikethrough-price {\n  margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
